import React from 'react';
import {connect} from "react-redux";

import ModuleDetails from './ModuleDetails';
import StoreList from './StoreList';
import Modules from './Modules';

import {
    deleteModule,
    showModulesArticles,
    showModulesStores,
    updateModuleQuery,
    createModule,
    updateModuleContract,
    updateModuleAssortment,
    updateModuleReplenishmentPeriod,
    activateUnlimitedStock,
    deactivateUnlimitedStock,
    addStoreToModule,
    removeStoreFromModule,
    getSelectedModule,
    fetchModules,
    fetchStores
} from './reducer';

import {getStoresNotAssignedToModule} from '../../retailer/reducer';
import CreateModuleModal from "./CreateModuleModal";

export class ModuleManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            moduleModalVisible: false
        };
        this.showModuleModal = this.showModuleModal.bind(this);
        this.hideModuleModal = this.hideModuleModal.bind(this);
        this.createNewModule = this.createNewModule.bind(this);
    }

    componentDidMount() {
        this.props.fetchModules();
        this.props.fetchStores();
    }

    showModuleModal() {
        this.setState({moduleModalVisible: true});
    }

    hideModuleModal() {
        this.setState({moduleModalVisible: false});
    }

    createNewModule(module) {
        this.props.createModule(module);
        this.hideModuleModal();
    }

    render() {
        return (
            <div className="animated fadeIn">
                <CreateModuleModal visible={this.state.moduleModalVisible}
                                   onSubmit={this.createNewModule}
                                   onCancel={this.hideModuleModal}/>
                <div className="row">
                    <div className="col">
                        <Modules
                            moduleQuery={this.props.moduleQuery}
                            modules={this.props.modules}
                            deleteModule={this.props.deleteModule}
                            showModulesArticles={this.props.showModulesArticles}
                            showModulesStores={this.props.showModulesStores}
                            showModuleModal={this.showModuleModal}
                            updateModuleContract={this.props.updateModuleContract}
                            updateModuleAssortment={this.props.updateModuleAssortment}
                            activateUnlimitedStock={this.props.activateUnlimitedStock}
                            deactivateUnlimitedStock={this.props.deactivateUnlimitedStock}
                            updateModuleReplenishmentPeriod={this.props.updateModuleReplenishmentPeriod}
                            updateModuleQuery={this.props.updateModuleQuery}/>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        {(this.props.selectedModule && this.props.showArticles) ?
                            <ModuleDetails /> : null}
                        {(this.props.selectedModule && this.props.showStores) ?
                            <StoreList
                                module={this.props.selectedModule}
                                storesNotInModule={this.props.storesNotInModule}
                                addStoreToModule={this.props.addStoreToModule}
                                removeStoreFromModule={this.props.removeStoreFromModule}
                                stores={this.props.associatedStores}
                            /> : null}
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {

    let selectedModule = getSelectedModule(state.module);
    selectedModule = selectedModule ? selectedModule.toJS() : null;

    const storeGlnsAssignedToModule = state.module.get('associatedStores').map((store) => store.get('gln'));

    const storesNotInModule = getStoresNotAssignedToModule(state.module.get('stores'), storeGlnsAssignedToModule).toJS();

    return {
        modules: state.module.get('modules').toJS(),
        moduleQuery: state.module.get('moduleQuery'),
        showArticles: state.module.get('showArticles'),
        showStores: state.module.get('showStores'),
        selectedModule: selectedModule,
        associatedStores: state.module.get('associatedStores').toJS(),
        storesNotInModule: storesNotInModule
    };
}

const ConnectedModuleManager = connect(mapStateToProps, {
    deleteModule,
    showModulesArticles,
    showModulesStores,
    updateModuleQuery,
    createModule,
    updateModuleContract,
    updateModuleAssortment,
    activateUnlimitedStock,
    deactivateUnlimitedStock,
    updateModuleReplenishmentPeriod,
    addStoreToModule,
    removeStoreFromModule,
    fetchModules,
    fetchStores,
})(ModuleManager);

export default ConnectedModuleManager;



// WEBPACK FOOTER //
// ./src/admin/module/overview/ModuleManager.js